import { virtualDir } from "./skyward.base.global";
import { closePopup, registerLayoutResizeCallback, removeLayoutResizeCallback } from "./skyward.ui.window";
import { ButtonDefinition, JQueryInput, ModalDialog } from "./types";

const skyward = window.skyward;

export let initialize = function (html: JQueryInput, area: string, controller: string, data?: object, saveOrderOverride?: (dialog: ModalDialog) => void)
{
    let $sortable: JQuery;
    let messageBox: ModalDialog;
    let originalIndex: number;
    let numberOfColumns: number;

    const sortableUpdate = function (updatedRow?: JQuery | null)
    {
        updateSortNumber(updatedRow);
        handleSortablePlaceholder();
        toggleSortableButtons();
    };

    const sortableOptions: JQueryUI.SortableOptions =
    {
        cancel: ".sortableDelete",
        cursor: "move",
        scroll: true,
        start: function (_e, ui)
        {
            originalIndex = ui.item.index();
        },
        update: function (_e, ui)
        {
            sortableUpdate(ui ? ui.item : null);
        },
        items: ".sortableRow",
        sort: function (_e, _ui)
        {
            handleSortablePlaceholder();
        },
        containment: "parent",
        tolerance: "pointer",
        axis: "y"
    };

    const updateSortNumber = function (updatedRow: JQuery | null | undefined)
    {
        const dropIndex = updatedRow ? (updatedRow.index() - 1) : 0;
        const start = Math.min(dropIndex, originalIndex - 1);
        const end = Math.max(dropIndex, originalIndex - 1) + 1;

        $sortable.find("td.sortColumn div").slice(start, end).each(function (index, element)
        {
            $(element).html(String(start + index + 1));
        });
    };

    const handleSortablePlaceholder = function ()
    {
        $(".sortableRow.ui-sortable-placeholder").not(".ui-sortable-helper").each(function (_index, value)
        {
            const element = $(value);
            element.html('<td colspan="' + numberOfColumns + '"></td>');
            element.css({ 'visibility': 'visible' });
        });
    };

    const getOrder = function ()
    {
        const list: { id: number; }[] = [];

        $sortable.find("tbody tr").slice(1).each(function (index, element)
        {
            list[index] = { 'id': $(element).data('id') };
        });

        return JSON.stringify(list);
    };

    const saveOrder = function ()
    {
        const saveAction = $("#saveAction");
        const container = $('#sortablecontentmessagearea');
        const postData = $.extend({}, data, { 'sortOrder': getOrder(), 'SortableID_SecurityHash': saveAction.data("sortableid_securityhash"), 'warninghashes': JSON.stringify(container.data("warninghashes")) });
        return $.ajax(
        {
            url: virtualDir + sortableArea + "/" + sortableController + "/" + saveAction.val(),
            type: "POST",
            data: postData,
            success: function (result)
            {
                if (result.success)
                {
                    messageBox.close();
                    refreshBrowse(saveAction.data("browsetorefreshaftersave"));
                }
                else
                {
                    let baseErrorContainer = $(messageBox.modalLayer.contents).find("#CurrentRecordContentBaseError");
                    if (typeof baseErrorContainer == "undefined" || baseErrorContainer == null || baseErrorContainer.length < 1)
                    {
                        baseErrorContainer = $("#CurrentRecordContentBaseError");
                    }

                    skyward.validation.displayValidationMessages(result, container, baseErrorContainer);
                }
            }
        });
    };

    const refreshBrowse = function (browseToRefreshAfterSave?: string)
    {
        const detailsPanelName = `detailsPanel_${browseToRefreshAfterSave}`;
        let browseRefreshed = false;

        // If there's a browse with the same name in the Winkelpanel as one outside it,   
        // we'll refresh both browses to ensure we get the right one. Refreshing both
        // shouldn't hurt anything.
        if (browseToRefreshAfterSave)
        {
            if (skyward.browse.browseList[browseToRefreshAfterSave])
            {
                skyward.browse.get(browseToRefreshAfterSave);
                browseRefreshed = true;
            }

            if (skyward.browse.browseList[detailsPanelName])
            {
                skyward.browse.get(detailsPanelName);
                browseRefreshed = true;
            }
        }

        if (!browseRefreshed)
        {
            window.location.reload();
        } 
    };

    const customSaveOrder = function ()
    {
        saveOrderOverride!(messageBox);
    };

    const showMessageBox = function ()
    {
        const saveButton: ButtonDefinition = { text: "Save", "click": (saveOrderOverride ? customSaveOrder : saveOrder), "icon": "Save" };
        const cancelButton: ButtonDefinition = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
        closePopup();
        messageBox = skyward.modalLayer.showDialog($(html).find("#sortableTitle").val() as string, html, [saveButton, cancelButton], { closeOnClick: false, hideOverflow: true });

        messageBox.bodyPromise.then(toggleSortableButtons);
    };

    const toggleSortableButtons = function ()
    {
        const allButtons = $sortable.find(".js-sortableUp,.js-sortableDown");
        const upButtons = allButtons.filter(".js-sortableUp");
        const downButtons = allButtons.filter(".js-sortableDown");

        const firstUpButton = upButtons.first();
        const lastDownButton = downButtons.last();

        // We must store this prior to disabling.  IE causes disabled elements to lose focus.
        // TODO (someday) check if this is still needed
        const firstUpButtonHasFocus = firstUpButton.is(":focus");
        const lastDownButtonHasFocus = lastDownButton.is(":focus");

        skyward.controls.disable(firstUpButton);
        skyward.controls.disable(lastDownButton);

        skyward.controls.enable(upButtons.not(firstUpButton));
        skyward.controls.enable(downButtons.not(lastDownButton));

        const activeButtons = allButtons.not(firstUpButton).not(lastDownButton);

        if (firstUpButtonHasFocus)
        {
            activeButtons.first().trigger("focus");
        }
        else if (lastDownButtonHasFocus)
        {
            activeButtons.last().trigger("focus");
        }
    };

    const sortableArea: string = area;
    const sortableController: string = controller;

    showMessageBox();

    $sortable = messageBox!.content.find(".sortable").first();
    const sortableBody = messageBox!.content.find("tbody");

    if (!skyward.global.mobileAccess)
    {
        sortableBody.sortable(sortableOptions);
    }

    sortableBody.disableSelection();

    $sortable.addClass("sortable__modal");

    const resizePanel = function ()
    {
        const topMostLayer = $("div.modalLayerContainer:last");
        if (topMostLayer.length <= 0)   //If sortable panel is closed, remove the callback event
        {
            removeLayoutResizeCallback(resizePanel);
        }
    };

    resizePanel();

    numberOfColumns = $('tr.sortableHeaderRow td').length;

    $sortable.on("click", ".sortableDelete", function()
    {
        const button = $(this);

        button.parents("tr").first().remove();
        originalIndex = $sortable.find(".sortableDelete").length;
        sortableUpdate();
    });

    $sortable.on("click", ".js-sortableUp", function ()
    {
        const button = $(this);
        const row = button.closest(".sortableRow");

        originalIndex = row.index();
        row.insertBefore(row.prev());

        button.trigger("focus");
        sortableUpdate(row);
    });

    $sortable.on("click", ".js-sortableDown", function ()
    {
        const button = $(this);
        const row = button.closest(".sortableRow");

        originalIndex = row.index();
        row.insertAfter(row.next());

        button.trigger("focus");
        sortableUpdate(row);
    });

    registerLayoutResizeCallback(resizePanel);
};